import { SimpleField } from "../../../../components/fields/simpleField.jsx";
import { ContactField } from "../../../../components/fields/contactField.jsx";
import React from "react";
import { useInternet } from "../../../../hooks/useInternet.js";
import { useResource } from "../../../../hooks/useResource.js";

export function InfoTab({ watch, control, setValue }) {
  let internet = useInternet();
  let productsService = useResource("products");
  let documentsService = useResource("documents");

  return (
    <div className={"flex flex-col gap-3 bg-white p-3"}>
      <div className={"flex gap-3"}>
        <div style={{ width: 200 }}>
          <SimpleField
            label="Type"
            name={"type"}
            control={control}
            select={{
              clearable: false,
              options: [
                {
                  value: "charge",
                  label: "charge",
                },
                {
                  value: "invoice",
                  label: "invoice",
                },
                {
                  value: "quote",
                  label: "quote",
                },
                {
                  value: "other",
                  label: "other",
                },
              ],
            }}
            type={"select"}
          />
        </div>
        <div className={"flex gap-3 flex-grow"}>
          <SimpleField label="Reference" name={"reference"} control={control} />
        </div>
      </div>
      <div className={"flex gap-3"}>
        <div className={"flex-grow basis-0"} style={{ maxWidth: 200 }}>
          <SimpleField
            label="Date"
            name={"date"}
            control={control}
            type={"date"}
            className={"flex-grow basis-1"}
          />
        </div>

        <div className={"flex-grow basis-0"}>
          <ContactField setValue={setValue} control={control} />
        </div>
      </div>
      {["invoice", "charge", "quote"].includes(watch("type")) && (
        <div className={"flex flex-col gap-3"}>
          <div className={"flex gap-3"}>
            <div style={{ maxWidth: 200 }}>
              <SimpleField
                label="Amount"
                name={"amount"}
                control={control}
                type={"number"}
                disabled={watch("lines")?.length > 0}
              />
            </div>
            <div style={{ width: 100 }}>
              <SimpleField
                label="Currency"
                name={"currency"}
                control={control}
                type={"text"}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
